import { createIcon } from '@chakra-ui/icons';

export const StarFilled = createIcon({
  displayName: 'StarFilled',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_925_39705)">
        <path
          d="M13.2515 4.75784L9.47501 4.20921L7.78539 0.787086C7.48964 0.189461 6.51139 0.189461 6.21564 0.787086L4.52689 4.20921L0.749512 4.75784C0.0346367 4.86196 -0.254988 5.74396 0.264762 6.25146L2.99826 8.91496L2.35339 12.6766C2.23176 13.3888 2.98076 13.9357 3.62301 13.5988L7.00051 11.8235L10.3789 13.5997C11.0159 13.9331 11.771 13.395 11.6485 12.6775L11.0036 8.91584L13.7371 6.25234C14.256 5.74396 13.9664 4.86196 13.2515 4.75784Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_925_39705">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
